import { demoCTA } from '../cta.js';

const DEMO_URL = demoCTA.url;

// Tasa de referencia para calcular precios USD que no se fijan a mano (ver Scout).
// Los demás planes fijan su priceUSD directamente (precio psicológico propio).
const USD_CLP_RATE = 980;
function calcUSD(clp) {
  return Math.round(clp / USD_CLP_RATE / 5) * 5;
}

export const PLANS = [
  {
    id: 'scout',
    eyebrow: 'PLAN · 01',
    name: 'Scout',
    description: 'Para probar el monitoreo en un solo motor.',
    price: '$ 95.000',
    priceUSD: `USD ${calcUSD(95000)}`,
    period: '/ mes · 15 prompts/sem · 1 motor',
    features: [
      'Score AEO 0–100 semanal, por motor',
      '200+ respuestas analizadas / mes',
      '3 ejecuciones por motor / semana',
      'Cobertura de motor generativo: ChatGPT',
      'Monitoreo de hasta 5 competidores',
      'Integración con Analytics y Search Console',
      'Detalle de respuestas de IA por ejecución',
    ],
    cta: 'Empezar con Scout',
    href: DEMO_URL,
    external: true,
    featured: false,
  },
  {
    id: 'radar',
    eyebrow: 'PLAN · 02',
    name: 'Radar',
    description: 'Para diagnosticar antes de comprometerte.',
    price: '$ 245.000',
    priceUSD: 'USD 249',
    period: '/ mes · 30 prompts/sem · 3 motores',
    features: [
      'Todo lo que incluye Scout',
      '1.600+ respuestas analizadas / mes',
      '4–5 ejecuciones por motor / semana',
      'Monitoreo de hasta 20 competidores',
      'Auditoría de schema.org y llms.txt',
      'Playbook de acciones y recomendaciones',
      'Reporte ejecutivo al CMO con prioridades',
    ],
    cta: 'Empezar con Radar',
    href: DEMO_URL,
    external: true,
    featured: false,
  },
  {
    id: 'growth',
    eyebrow: 'PLAN · 03 · RECOMENDADO',
    name: 'Growth',
    description: 'Para empresas que lideran la conversación en IA.',
    price: '$ 875.000',
    priceUSD: 'USD 899',
    period: '/ mes · 100 prompts/sem · 5 motores',
    features: [
      'Todo lo que incluye Radar',
      '6.700+ respuestas analizadas / mes',
      'Generación de contenido AEO',
      'Bison Agent integrado al dashboard',
      'Servidor MCP — conecta tu propio agente',
      'Webhooks + alertas en tiempo real',
      '1 sesión estratégica / mes',
    ],
    cta: 'Empezar con Growth',
    href: DEMO_URL,
    external: true,
    featured: true,
  },
  {
    id: 'enterprise',
    eyebrow: 'PERSONALIZADO',
    name: 'Enterprise',
    description: 'Operaciones que exigen escala y control total, con SLA, SSO e integración de datos.',
    price: 'A medida',
    priceUSD: 'A medida',
    period: '/ retainer trimestral',
    features: [
      'Todo lo que incluye Growth',
      'SLA dedicado · SSO · Account Manager',
      'Sincronización API y data warehouse',
      'Benchmarks de LLMs personalizados',
      'Onboarding estratégico multi-país',
      'Playbook de acciones e implementación',
      'Motores de IA personalizados',
    ],
    cta: 'Hablar con ventas',
    href: DEMO_URL,
    external: true,
    featured: false,
  },
];

// Compilado para el MCP público (public/planes.json → worker-mcp: consultar_planes).
// Sin campos de presentación (eyebrow, cta, href, featured).
export const ALL_PLANS = PLANS.map((p) => ({
  name: p.name,
  description: p.description,
  priceCLP: p.price,
  priceUSD: p.priceUSD,
  period: p.period,
  features: p.features,
}));

// Planes con precio público: los «tres niveles» que cuentan /planes y su metadata. Enterprise (a medida)
// queda fuera del conteo. De aquí salen el título y la descripción de /planes (metadata y schema).
export const PRICED_PLANS = PLANS.filter((p) => p.price !== 'A medida');

const NUMEROS = ['Cero', 'Un', 'Dos', 'Tres', 'Cuatro', 'Cinco', 'Seis'];
const listaES = (items) => (items.length > 1 ? `${items.slice(0, -1).join(', ')} y ${items.at(-1)}` : items.join(''));

export const PLANES_META = {
  title: `Planes y precios AEO — ${listaES(PRICED_PLANS.map((p) => p.name))}`,
  description: `${NUMEROS[PRICED_PLANS.length] ?? PRICED_PLANS.length} planes AEO: ${listaES(
    PRICED_PLANS.map((p) => `${p.name} desde ${p.price}/mes`),
  )}. Monitoreo en ChatGPT, Gemini y Perplexity. Sin permanencia.`,
};
